import {
  IconRotate2,
  IconRotateClockwise2,
  IconTrash,
} from '@rossum/ui/icons/tabler';
import { IconButton, Stack, SvgIcon } from '@rossum/ui/material';
import { DispatchEdit, Part } from '../document-edit-core';

export const EditedPartActions = ({
  part,
  dispatchEdit,
}: {
  part: Part;
  dispatchEdit: DispatchEdit;
}) => {
  const { pages } = part;

  return (
    <Stack
      direction="row"
      spacing={1}
      data-cy="part-actions"
      sx={{ alignItems: 'center', flexShrink: 0 }}
    >
      <IconButton
        onClick={() =>
          dispatchEdit({
            type: 'BATCH_ACTION',
            actions: pages.map(p => ({
              type: 'ROTATE_PAGE',
              pageNumber: p.pageNumber,
              rotationDeg: p.rotationDeg - 90,
            })),
          })
        }
        data-cy="document-edit-batch-rotate-page-counter-clockwise-btn"
        size="small"
      >
        <SvgIcon fontSize="medium" color="secondary">
          <IconRotate2 />
        </SvgIcon>
      </IconButton>
      <IconButton
        onClick={() =>
          dispatchEdit({
            type: 'BATCH_ACTION',
            actions: pages.map(p => ({
              type: 'ROTATE_PAGE',
              pageNumber: p.pageNumber,
              rotationDeg: p.rotationDeg + 90,
            })),
          })
        }
        data-cy="document-edit-batch-rotate-page-clockwise-btn"
        size="small"
      >
        <SvgIcon fontSize="medium" color="secondary">
          <IconRotateClockwise2 />
        </SvgIcon>
      </IconButton>
      <IconButton
        onClick={() => {
          const allPagesAreDeleted = pages.every(p => p.deleted);

          return dispatchEdit({
            type: 'BATCH_ACTION',
            actions: pages.map(p => ({
              type: 'DELETE_PAGE',
              pageNumber: p.pageNumber,
              deleted: !allPagesAreDeleted,
            })),
          });
        }}
        data-cy="document-edit-batch-delete-page-btn"
        size="small"
      >
        <SvgIcon fontSize="medium" color="secondary">
          <IconTrash />
        </SvgIcon>
      </IconButton>
    </Stack>
  );
};
